import { useEffect, useRef, useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import { useQuery } from "@tanstack/react-query";
import BaseTextField from "../../../components/ui/BaseTextField";
import BaseButton from "../../../components/ui/BaseButton";
import { fetchCompanyUsers } from "../../../services/api/company";
import { Chip } from "@mui/material";
import AddEditRoleModal from "./components/AddEditRoleModal";
import BaseDataTableV2 from "../../../components/ui/BaseDataTableV2";
import { debounce } from "../../../utils/helpers";
import BaseDropdownV2 from "../../../components/ui/BaseDropdownV2";
import ConfirmDeactivateUserModal from "./components/ConfirmDeactivateCompnayUserModal";
import ConfirmActivateUserModal from "./components/ConfirmActivateUserModal";
import { useCurrentUser } from "../../../hooks/useCurrentUser";
import CompleteProfileModal from "../../WorkJobDetails/CompleteProfileModal";
import useAuth from "../../../hooks/useAuth";
import { fetchAllCompanyDesignations } from "../../../services/api/designation";
import { useNavigate } from "react-router-dom";

const menuOptions = [
  {
    label: "Edit",
    value: "EDIT",
  },
  {
    label: "Delete",
    value: "DELETE",
  },
];

const RolesListingTable = () => {
  const navigate = useNavigate();
  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [isAddEditRoleOpen, setIsAddEditRoleOpen] = useState(null);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [search, setSearch] = useState("");
  const { userData } = useCurrentUser();

  const {
    data: desginationsData,
    isPending: isFetchAllCompanyDesignationsApiLoading,
    error: isFetchAllCompanyDesignationsApiError,
    refetch: refetchAllCompanyDesignations,
  } = useQuery({
    queryKey: ["companyDesginations"],
    queryFn: () => fetchAllCompanyDesignations(),
  });

  const updateSearchDebounced = useRef(
    debounce((query) => {
      setSearch(query.trim().toLowerCase());
      setPaginationModel((prev) => ({ ...prev, page: 0 }));
    }, 500),
  ).current;

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    updateSearchDebounced(query);
  };

  // The designations endpoint returns the full list, so filter locally.
  const filteredDesignations = (desginationsData?.data || []).filter((role) =>
    search
      ? `${role?.designation ?? ""} ${role?.description ?? ""}`.toLowerCase().includes(search)
      : true,
  );

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 0.5,
      minWidth: 80,
      renderCell: (params) => (
        <p
          className="text-primary cursor-pointer"
          onClick={() => handleDesignationClick(params?.row)}
        >
          {params?.value}
        </p>
      ),
    },
    {
      field: "designation",
      headerName: "Designation",
      flex: 0.5,
      minWidth: 150,
      renderCell: (params) => (
        <p
          className="text-primary cursor-pointer capitalize"
          onClick={() => handleDesignationClick(params?.row)}
        >
          {params.value}
        </p>
      ),
    },
    {
      field: "description",
      headerName: "Description",
      flex: 2,
      minWidth: 240,
      renderCell: (params) => <p>{params.value}</p>,
    },

    {
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      minWidth: 90,
      renderCell: (params) => {
        return (
          <BaseDropdownV2
            menuOptions={menuOptions}
            triggerElement={<i className="fa-solid fa-ellipsis cursor-pointer ml-4 text-base"></i>}
            onItemClick={(item) => handleItemClick(item, params?.row)}
          />
        );
      },
    },
  ];

  const handleItemClick = async (value, data) => {
    setSelectedDesignation(data);
    if (value === "EDIT") {
      setIsAddEditRoleOpen(true);
    }
  };

  const handleDesignationClick = (designation) => {
    navigate(
      `/company/${designation.designation
        ?.toLowerCase()
        ?.replace(/\s+/g, "")}/permissions/${designation.id}`,
    );
  };

  return (
    <>
      <BaseCard elevation={0} className="py-4 px-5 rounded-xl shadow-lg ">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 w-full">
          <div className="w-full sm:w-2/6">
            <BaseTextField
              placeholder="Search by role or description"
              value={searchQuery}
              onChange={handleSearchChange}
              startAdornment={<i className="fa-light fa-magnifying-glass text-lg"></i>}
            />
          </div>

          <BaseButton
            color="primary"
            className="!py-[5px] whitespace-nowrap w-full sm:w-auto"
            onClick={() => setIsAddEditRoleOpen(true)}
            /*   onClick={() => {
              if (userData?.status !== "APPROVED") {
                setIsProfileCompleted(true);
                return;
              }
              setIsAddEditRoleOpen(true);
              setSelectedUser(null);
            }} */
          >
            Add New Role
          </BaseButton>
        </div>
      </BaseCard>
      <BaseDataTableV2
        className="max-h-[calc(100vh-320px)] overflow-auto"
        columns={columns}
        data={filteredDesignations}
        isLoading={isFetchAllCompanyDesignationsApiLoading}
        isCellEditable={(params) => false}
        hideFooter={false}
        pagination
        pageSizeOptions={[10, 20, 50, 100]}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
      />

      {isAddEditRoleOpen && (
        <AddEditRoleModal
          open={isAddEditRoleOpen}
          close={setIsAddEditRoleOpen}
          // setCompanyUsersList={setCompanyUsersList}
          selectedDesignation={selectedDesignation}
          setSelectedDesignation={setSelectedDesignation}
          refetchAllCompanyDesignations={refetchAllCompanyDesignations}
        />
      )}
      {/* {isConfrimDeactivateUserOpen && (
        <ConfirmDeactivateUserModal
          deactivateModalOpen={isConfrimDeactivateUserOpen}
          setDeactivateModalOpen={setIsConfrimDeactivateUserOpen}
          userId={selectedUser?.id}
          refetchUsers={refetch}
        />
      )} */}
      {/* {isConfrimActivateUserOpen && (
        <ConfirmActivateUserModal
          activateModalOpen={isConfrimActivateUserOpen}
          setActivateModalOpen={setIsConfrimActivateUserOpen}
          userId={selectedUser?.id}
          refetchUsers={refetch}
        />
      )} */}
      {/* {isProfileCompleted && (
        <CompleteProfileModal
          isProfileCompleted={isProfileCompleted}
          setIsProfileCompleted={setIsProfileCompleted}
          status={userData?.status}
          authRole={authRole}
        />
      )} */}
    </>
  );
};

export default RolesListingTable;
